import { Link } from 'react-router-dom';
import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <Link to="/" data-id="element-395">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h3seDyBZHw8grzxvh3ioQc/Rectangle_1_%281%29.png" alt="CreatorBoost Logo" className={`h-24 ${className}`} data-id="element-396" />
    </Link>;
};